export default __webpack_public_path__ + "static/media/2263.e41fb33c.png";